module.exports = __webpack_public_path__ + "static/media/logo.55923f47.svg";